import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header from "../Header";
import Footer from "../Footer";
import { ListMenuIcon, ListMenuReact } from "../Menu";
import ThongBaoCapNhapContainer from "containers/Common/ThongBao/ThongBaoCapNhapContainer";
import GoiPhanMemApi from "../../service/goiPhanMemApi";
import CauHinhApi from "../../service/cauHinhApi";
import { Cookies } from "react-cookie";
import config from "../../constants/configs";
// import CacheBuster from 'react-cache-buster';
import { version } from "../../../package.json";

const Layout = (props) => {
  const cookies = new Cookies();
  const [isScrolled, setScroll] = useState(window.scrollY > 30);
  let {
    quanlycuahang,
    getComboCuaHang,
    chuyenCuaHang,
    thongTinCuaHangHienTai,
    user,
    getCurrentUser,
    getMenu,
    menu,
    getBadgeMenu,
    getListThongBao,
    thongbao,
  } = props;
  let {
    listCuaHang,
    ComboCuaHangLoaded,
    thongTinCuaHang,
    chuyenCuaHangLoading,
  } = quanlycuahang ? quanlycuahang : {};
  useEffect(() => {
    var cookieMenu = localStorage.getItem('getMenu');
    var dataMenu1 = localStorage.getItem('dataMenu');
    let objMenuSave = [];
    if (typeof dataMenu1 !== "undefined") {
      objMenuSave = JSON.parse(dataMenu1);
    }
    getBadgeMenu();

    // if (typeof cookieMenu === "undefined" || cookieMenu != "1" || objMenuSave.length == 0) {
      getMenu();
    // }
    thongTinCuaHangHienTai();
    getComboCuaHang();
    getCurrentUser();
    getListThongBao();

    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const Y = window.scrollY;
    setScroll(Y > 30);
  };
  const chuyenCuaHangHH = (macuahang) => () => {
    chuyenCuaHang({ macuahang });
  };
  if (chuyenCuaHangLoading === false) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  let { currentUser } = user ? user : {};
  let { objMenu, objBadgeMenu } = menu;
  // var cookieMenu = localStorage.getItem('getMenu')
  // if (objMenu.length > 0 && (typeof cookieMenu === "undefined" || cookieMenu != "1")) {
  //   localStorage.setItem('getMenu', "1");
  //   cookieMenu = "1";
  //   localStorage.setItem('dataMenu', JSON.stringify(objMenu));

  // }
  // if (cookieMenu === "1" && objMenu.length == 0) {
  //   objMenu = [];
  //   let objMenuSave = JSON.parse(localStorage.getItem('dataMenu'));
  //   objMenu = objMenuSave;

  // }

  let { List, Total, NotiId } = thongbao.objListThongBao;
  let isShowNoti = NotiId !== 0 && NotiId !== null && NotiId !== undefined;
  const currentURL = window.location.pathname;
  //alert(currentURL);
  return (
    //   <CacheBuster
    //   currentVersion={version}
    //   isEnabled={true} //If false, the library is disabled.
    //   isVerboseMode={true} //If true, the library writes verbose logs to console.
    //   // loadingComponent={reloadPage} //If not pass, nothing appears at the time of new version check.
    //   // metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    // >
    <Fragment>
      <Header
        className="pt-10"
        showBackground={isScrolled}
        list={listCuaHang}
        onChange={chuyenCuaHangHH}
        thongTin={thongTinCuaHang}
        userInfo={currentUser}
        thongBao={thongbao.objListThongBao}
      />
      <div
        className="main-menu menu-fixed menu-light menu-accordion menu-shadow "
        data-scroll-to-active="true"
      >
        <div className="main-menu-content">
          <ul
            className="navigation navigation-main"
            id="main-menu-navigation"
            data-menu="menu-navigation"
          >
            {/* <li class=" nav-item hidden-des-main show-mobile-main">
              <a href={window.mormanServer + "trang-chu.aspx"}>
                &nbsp;<i class="fas fa-home font-menu"></i>
                <span class="menu-title">Trang chủ </span>
              </a>
            </li> */}
            {objMenu &&
              objMenu.map((item) => (
                <li
                  className={
                    "nav-item" +
                    (item.subItems && item.subItems.length > 0
                      ? " has-sub"
                      : "") +
                    ("/" + item.link == currentURL ? "open active" : "")
                  }
                  key={item.code}
                >
                  {
                    // console.log(ListMenuReact.ListMenuCode.indexOf(item.code) >= 0 ? config.mormanReact + item.link : config.mormanServer + item.link, "("+item.link + "|" + item.code+")")
                  }
                  <a
                    href={
                      item.link === "#"
                        ? "#"
                        : ListMenuReact.ListMenuCode.indexOf(item.code) >= 0
                          ? config.mormanReact + item.link
                          : config.mormanServer + item.link
                    }
                  >
                    <i className={ListMenuIcon[item.code]}></i>
                    <span className="menu-title">
                      {item.code === "nhanvay" ? "Huy động vốn" : item.name}
                    </span>
                    {objBadgeMenu[item.code] ? (
                      <span class="badge badge badge-info badge-pill float-right mr-2">
                        {objBadgeMenu[item.code]}
                      </span>
                    ) : (
                      ""
                    )}
                  </a>
                  {item.subItems && item.subItems.length > 0 && (
                    <ul className="menu-content">
                      {item.subItems.map((itemSub, index) => (
                        <li
                          key={item.code + index}
                          className={
                            "/" + itemSub.link == currentURL
                              ? "open active"
                              : ""
                          }
                        >
                          <a
                            className="menu-item"
                            href={
                              ListMenuReact.ListMenuCode.indexOf(
                                itemSub.code
                              ) >= 0
                                ? config.mormanReact + itemSub.link
                                : config.mormanServer + itemSub.link
                            }
                          >
                            <i className={"fas fa-caret-right"}></i>
                            <span className="menu-title">
                              {itemSub.code === "quytienmat"
                                ? "Dòng tiền"
                                : itemSub.name}
                            </span>
                            {objBadgeMenu[itemSub.code] ? (
                              <span class="badge badge badge-info badge-pill float-right mr-2">
                                {objBadgeMenu[itemSub.code]}
                              </span>
                            ) : (
                              ""
                            )}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row"></div>
          <div className="content-body">
            <div id="form-repeater">{props.children}</div>
          </div>
        </div>
      </div>
      {isShowNoti && (
        <ThongBaoCapNhapContainer id={NotiId}></ThongBaoCapNhapContainer>
      )}
      <Footer thongTin={thongTinCuaHang} />
    </Fragment>
    // </CacheBuster>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default Layout;
